import layout from '../../internal/Layout.vue'
import UnitaryAvoidedCosts from './components/UnitaryAvoidedCosts/unitaryAvoidedCosts.vue'
import RecurrentAvoidedCosts from './components/RecurrentAvoidedCosts/recurrentAvoidedCosts.vue'
import AvoidedCostsReports from './components/AvoidedCostsReports/avoidedCostsReports.vue'
import AvoidedCostsNature from './components/AvoidedCostsNature/AvoidedCostsNature.vue'

const AvoidedCosts = {
  component: layout,
  children: [
    {
      name: 'unitaryAvoidedCosts',
      path: '/unitaryAvoidedCosts',
      component: UnitaryAvoidedCosts,
      meta: {
        module: 'unitary_avoided_costs',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
    {
      name: 'recurrentAvoidedCosts',
      path: '/recurrentAvoidedCosts',
      component: RecurrentAvoidedCosts,
      meta: {
        module: 'recurrent_avoided_costs',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
    {
      name: 'avoidedCostsReports',
      path: '/avoidedCostsReports',
      component: AvoidedCostsReports,
      meta: {
        module: 'avoided_costs_reports',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
    {
      name: 'avoidedCostsNature',
      path: '/avoidedCostsNature',
      component: AvoidedCostsNature,
      meta: {
        module: 'avoided_costs_nature',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: false,
      },
    },
  ],
}
export default AvoidedCosts
